<template>
  <div class="row" id="resultado-municipal">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Por equipe">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Por equipe
          </template>
          <dashboard
            :cadastros="dadosDashboard"
            :loadingPage="loading"
          ></dashboard>
        </b-tab>
        <b-tab title="Por indicador">
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Por indicador
          </template>
          <por-indicador
            :cadastros="dadosDashboard"
            :loadingPage="loading"
          ></por-indicador>
        </b-tab>
        <b-tab title="Ranking">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Ranking
          </template>
          <tabela-percentual
            ref="table"
            :cadastros="dadosPercentual"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-percentual>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import TabelaPercentual from './TabelaPercentual.vue'
import Dashboard from './Dashboard'
import PorIndicador from './PorIndicador'

export default {
  name: 'ResultadoMunicipal',
  components: {
    Subtitle,
    TitleTag,
    PulseLoader,
    TabelaPercentual,
    Dashboard,
    PorIndicador,
  },
  mixins: [utils],
  data() {
    return {
      loading: false,
      tabsActive: 0,
      dadosPercentual: [],
      dadosDashboard: [],
    }
  },
  computed: {},
  methods: {
    async init() {
      try {
        this.loading = true
        let response = await this.$api.get(
          `/app/indicadores-aps/resultado-municipal/${this.$store.state.cod_ibge}`
        )
        if (response) {
          this.dadosPercentual = response.data
          this.dadosDashboard = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped></style>
